import React from "react";
import { Form, Input, DatePicker } from "antd";

const IndividForm = props => {
  const { form } = props;
  const { getFieldDecorator } = form;

  return (
    <div className="customer-card-form__individ">
      <div className="customer-card-form__main-block">
        <>
          <div className="customer-card-form__unit">
            <span className="customer-card-form__label">Наименование:</span>
            <div className="customer-card-form__item">
              <Form.Item>
                {getFieldDecorator("nameLegal")(
                  <Input
                    disabled
                    className="customer-card-form__input"
                    style={{ width: 368 }}
                  />
                )}
              </Form.Item>
            </div>
          </div>
          <div className="customer-card-form__unit">
            <span className="customer-card-form__label">
              Юридический адрес:
            </span>
            <div className="customer-card-form__item">
              <Form.Item>
                {getFieldDecorator("addressLegal")(
                  <Input
                    disabled
                    className="customer-card-form__input"
                    style={{ width: 368 }}
                  />
                )}
              </Form.Item>
            </div>
          </div>
          <div className="customer-card-form__unit">
            <span className="customer-card-form__label">Дата регистрации:</span>
            <div className="customer-card-form__item">
              <Form.Item>
                {getFieldDecorator("registrationDate")(
                  <DatePicker
                    disabled
                    style={{ width: 224 }}
                    format={"DD.MM.YYYY"}
                  />
                )}
              </Form.Item>
            </div>
          </div>
          <div className="customer-card-form__unit">
            <span className="customer-card-form__label">ИНН:</span>
            <div className="customer-card-form__item">
              <Form.Item>
                {getFieldDecorator("inn")(
                  <Input
                    disabled
                    className="customer-card-form__input"
                    style={{ width: 368 }}
                  />
                )}
              </Form.Item>
            </div>
          </div>
          <div className="customer-card-form__unit">
            <span className="customer-card-form__label">ОГРНИП:</span>
            <div className="customer-card-form__item">
              <Form.Item>
                {getFieldDecorator("ogrn")(
                  <Input
                    disabled
                    className="customer-card-form__input"
                    style={{ width: 368 }}
                  />
                )}
              </Form.Item>
            </div>
          </div>
          {/*<div className="customer-card-form__unit">*/}
          {/*  <span className="customer-card-form__label">Статус:</span>*/}
          {/*  <div className="customer-card-form__item">*/}
          {/*    <Form.Item>*/}
          {/*      {getFieldDecorator("status")(*/}
          {/*        <Input*/}
          {/*          disabled*/}
          {/*          className="customer-card-form__input"*/}
          {/*          style={{ width: 224 }}*/}
          {/*        />*/}
          {/*      )}*/}
          {/*    </Form.Item>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </>
      </div>
    </div>
  );
};

export default IndividForm;
